module.exports = __webpack_public_path__ + "static/media/app_store_button.bbb1985c.png";